import { Http, formatBaseResponse } from './http'

export const appdownload = (param) => new Http('/system/appUpgrade/download' + param).header().backAll(true).exec(formatBaseResponse)

export const getAllVersionInfo = () => new Http('/system/appUpgrade/getAllVersionInfo').body().backAll(true).exec(formatBaseResponse)